import { fetchFluxBotAction } from "@/api/endpoints/fluxbot";

export async function createFluxBotSwap({
	wallet,
	inMint,
	outMint,
	inAmount,
}: {
	wallet: string;
	inMint: string;
	outMint: string;
	inAmount: number;
}): Promise<any> {
	return await fetchFluxBotAction(wallet, "swap", {
		source: inMint,
		dest: outMint,
		aToB: true,
		amount: Number(inAmount),
	});
}
